module.exports = __webpack_public_path__ + "static/media/jordan3.be0d182a.jpg";